import { Box, IconButton, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';
import { storySelector } from '@/store/selectors';
import { FC, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';
import { MuiButton, MuiIconButton } from '@/components';
import { CloseTypeStoryModal, OpenTypeStoryModal, setCreateSection } from '@/store/actions';
import { useDispatch } from 'react-redux';
import { TypeStory } from '../TypeStory';
import { palette } from '@/theme/constants';
import MuiTextField3 from '@/components/TextField3';
import { FormikConfig } from './formik';
import ImageUploadBox from '@/components/ImageUpload';
import { fileConverter } from '@/utils';

export const FormStories: FC<any> = ({
  values,
  setValues,
  setSelectedForm,
  actualFormNumber,
  handleCreateStories,
  creating,
}) => {
  const { t } = useTranslation();
  const createData = useSelector(storySelector);
  const { storySection } = createData;
  const router = useRouter();
  const dispatch = useDispatch();
  const formik = FormikConfig(handleCreateStories);

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  const storyTemplates = [
    {
      title: 'Life Story',
      key: 'life_story',
      url: 'life-story',
      content: 'life_story_content',
      bgcolor: '#FFF5F2',
      header_color: '#FED9D1',
      color: '#B97B6E',
      icon: '/icons/lifeStory.svg',
      position: 'center',
    },

    {
      title: 'Custom Story',
      key: 'custom_story',
      text: 'custom_story',
      value: 6,
      url: 'custom-story',
      bgcolor: '#0072CE03',
      header_color: '#3F44C2',
      color: '#DCECF9',
      content: 'custom_story',
      icon: '/images/logo-light-blue.svg',
      position: 'center',
    },
    {
      title: 'Wedding Story',
      key: 'wedding_story',
      url: 'wedding-story',
      content: 'wedding_story_content',
      bgcolor: '#0072CE21',
      header_color: '#0072CE',
      color: '#D8E8F6',
      icon: '/icons/wedding.svg',
      position: 'bottom',
    },
    {
      title: 'Retirement Story',
      key: 'retirement_story',
      url: 'retirement-story',
      content: 'retirement_story_content',
      bgcolor: '#89D3FF33',
      header_color: '#89D3FF',
      color: '#0072CE',
      icon: '/icons/retirement.svg',
      position: 'bottom',
    },
    {
      title: 'Classmates Story',
      key: 'classmates_story',
      bgcolor: 'rgba(241, 224, 255, 0.6)',
      header_color: 'rgba(241, 224, 255, 0.8)',
      color: '#8C58B8',
      icon: '/icons/classmate.svg',
      position: 'bottom',
    },
    {
      title: 'Teammates Story',
      key: 'teammates_story',
      bgcolor: '#FFF5F2',
      header_color: '#FED9D1',
      color: '#B97B6E',
      icon: '/icons/teammate.svg',
      position: 'bottom',
    },
    {
      title: 'Tribute Story',
      key: 'tribute_story',
      bgcolor: 'rgba(0, 114, 206, 0.13)',
      header_color: '#0072CE',
      color: '#D8E8F6',
      icon: '/icons/tribute.svg',
      position: 'bottom',
    },
    {
      title: 'Misc. Story',
      key: 'none_of_this_story',
      bgcolor: 'rgba(0, 114, 206, 0.13)',
      header_color: '#0072CE',
      color: '#D8E8F6',
      icon: '/icons/tribute.svg',
      position: 'bottom',
    },
    {
      title: 'Custom Event',
      key: 'custom_event',
      bgcolor: 'rgba(0, 114, 206, 0.13)',
      header_color: '#0072CE',
      color: '#D8E8F6',
      icon: '/icons/lifeStory.svg',
      position: 'center',
    },
  ];
  const [openModal, setOpenModal] = useState(false);
  const [selectedStory, setSelectedStory] = useState(storyTemplates[0]);
  const [errors, SetErrors] = useState(false);
  const [loading, setLoading] = useState(true);
  const [CoverRemoved, SetCoverRemoved] = useState(false);
  const { mem } = router.query;

  useEffect(() => {
    setValues(formik.values);
  }, [formik.values, setValues]);

  useEffect(() => {}, [values]);
  useEffect(() => {
    if (!mem) return;

    const matchedStory = [storyTemplates[0], ...storyTemplates].find((item) => item.key === mem);

    if (matchedStory) {
      setSelectedStory(matchedStory);
      localStorage.setItem('storyType', matchedStory?.key);
      dispatch(setCreateSection(matchedStory.key));
      dispatch(CloseTypeStoryModal());
    }
    setTimeout(() => {
      setLoading(false);
    }, 600);
  }, [mem, dispatch]);

  useEffect(() => {
    if (storySection) setSelectedForm([storySection]?.[actualFormNumber]?.name);
  }, [actualFormNumber, storySection, setSelectedForm]);
  const useBodyBackground = (color: string = '#fff') => {
    useEffect(() => {
      document.body.style.background = color;

      return () => {
        document.body.style.background = '';
      };
    }, [color]);
  };
  useBodyBackground(selectedStory?.bgcolor);

  const [coverImage, setCoverImage] = useState<string | null>(null);

  const handleImageUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      // Process image through fileConverter to handle EXIF orientation
      const processedFile = file.type.startsWith('image/') ? await fileConverter(file) : file;
      const finalFile = processedFile || file;
      const imageUrl = URL.createObjectURL(finalFile);
      setCoverImage(imageUrl);
      formik.setFieldValue('cover_image', finalFile);
    }
  };

  const handleBack = () => {
    router.push('/app/home');
    dispatch(OpenTypeStoryModal());
  };
  const backtostory = () => {
    setOpenModal(false);
  };
  const handleImageDelete = () => {
    setCoverImage(null);
    formik?.setFieldValue('cover_image', null);
    SetCoverRemoved(true);
  };
  useEffect(() => {
    if (CoverRemoved) {
      setCoverImage(null);
    }
  }, [CoverRemoved]);
  return (
    <>
      {loading ? (
        <Box width={'100%'} height={'100vh'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
          <Image priority src='/images/Loading.svg' quality={'100'} alt='loading' fill style={{ objectFit: 'cover' }} />
        </Box>
      ) : (
        <>
          {!openModal && (
            <>
              {!isMobile && (
                <Image
                  priority
                  src={`${selectedStory.icon}`}
                  style={{ zIndex: '-1', position: 'absolute', top: '47%', left: '30%' }}
                  width={764}
                  height={504}
                  alt='icons'
                />
              )}
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                }}
              />

              <Box
                width='100%'
                height='86px'
                bgcolor={selectedStory.header_color}
                display='flex'
                alignItems='center'
                justifyContent='center'>
                <Box maxWidth='1200px' width='100%' padding='0 16px' display='flex' alignItems='center'>
                  <IconButton
                    onClick={() => handleBack()}
                    sx={{ position: 'absolute', color: selectedStory.color, marginRight: '0px' }}>
                    <Image priority src={'/icons/left-arrow-black.svg'} width={20} height={20} alt='back' />
                  </IconButton>
                  <Typography variant='h4' color={selectedStory.color} sx={{ flexGrow: 1, textAlign: 'center' }}>
                    {t(selectedStory?.title)}
                  </Typography>
                </Box>
              </Box>

              <Box
                display='flex'
                flexDirection='column'
                alignItems='center'
                maxWidth='400px'
                paddingBottom={'100px'}
                mt={'1.3rem'}
                mx='auto'
                px={3}
                borderRadius={2}
                zIndex={100}
                width='100%'>
                <Typography color='#212d6d' fontSize='1rem' textAlign='left' alignSelf='start' width='100%' mb={'6px'}>
                  Name this story
                </Typography>
                <MuiTextField3
                  id='title'
                  name='title'
                  value={formik.values.title}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  fullWidth
                  placeholder='Name this story'
                  error={formik.touched.title && Boolean(formik.errors.title)}
                  helperText={formik.touched.title && formik.errors.title}
                />
                <Box
                  width='350px'
                  height={380}
                  display='flex'
                  my={'1.25rem'}
                  flexDirection='column'
                  alignItems='center'
                  justifyContent='center'
                  bgcolor='rgba(254, 254, 254, 0.4)'
                  border='1.9px dashed rgba(217, 217, 217, 1)'
                  borderRadius='8px'
                  position='relative'
                  sx={{
                    backgroundBlendMode: 'overlay',
                    cursor: 'pointer',
                    mb: 2,
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      background: 'rgba(167, 165, 165, 0.1)',
                      borderRadius: '8px',
                      zIndex: 1,
                    },
                  }}>
                  {coverImage ? (
                    <>
                      <Image
                        priority
                        src={coverImage}
                        alt='Cover'
                        layout='fill'
                        objectFit='cover'
                        style={{ zIndex: 2 }}
                      />

                      {/* DELETE ICON */}
                      <MuiIconButton
                        method={handleImageDelete}
                        sx={{
                          position: 'absolute',
                          top: 8,
                          right: 8,
                          backgroundColor: 'rgba(0,0,0,0.6)',
                          color: 'white',
                          zIndex: 4,
                          '&:hover': {
                            backgroundColor: 'rgba(0,0,0,0.8)',
                          },
                        }}
                        icon='/icons/delete'
                        iconHeight={15}
                        iconWidth={15}
                        altIcon='delete'
                      />
                    </>
                  ) : (
                    <>
                      <Image
                        priority
                        src='/icons/upload.svg'
                        alt='Upload'
                        width={40}
                        height={40}
                        style={{ zIndex: 2 }}
                      />
                      <Typography color={palette?.black} align='center' variant='body2' mt={1} sx={{ zIndex: 2 }}>
                        Upload a cover <br /> photo
                      </Typography>
                      <Typography color='#5C6372' fontSize={'0.8rem'} sx={{ zIndex: 2 }}>
                        (Optional)
                      </Typography>
                    </>
                  )}

                  <input
                    type='file'
                    accept='image/*'
                    style={{
                      position: 'absolute',
                      width: '100%',
                      height: '100%',
                      opacity: 0,
                      cursor: 'pointer',
                      zIndex: 3,
                    }}
                    onChange={handleImageUpload}
                  />
                </Box>

                <Typography color='#212d6d' fontSize='1rem' textAlign='left' alignSelf='start' width='100%' mb={'6px'}>
                  Description (Optional)
                </Typography>
                <MuiTextField3
                  name='description'
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  fullWidth
                  placeholder='A quick blurb about this story.'
                  variant='outlined'
                  multiline
                  height={'132px'}
                  minRows={6}
                  maxRows={6}
                  sx={{ mb: '2rem', height: '153px', bgcolor: 'white' }}
                  error={formik.touched.description && Boolean(formik.errors.description)}
                  helperText={formik.touched.description && formik.errors.description}
                />

                <MuiButton
                  loading={creating}
                  method={handleCreateStories}
                  disabled={!formik.values.title?.trim() || Object.keys(formik.errors).length > 0}
                  height='65px'
                  sx={{
                    backgroundColor: '#212d6d',
                    color: 'white',
                    gap: '1.6rem',
                    py: 2,
                    borderRadius: '8px',
                    opacity: !formik.values.title?.trim() || Object.keys(formik.errors).length > 0 ? 0.5 : 1,
                    pointerEvents:
                      !formik.values.title?.trim() || Object.keys(formik.errors).length > 0 ? 'none' : 'auto',
                    '&:hover': {
                      backgroundColor: '#0F1235',
                      opacity: !formik.values.title?.trim() || Object.keys(formik.errors).length > 0 ? 0.5 : 1,
                    },
                    '&:disabled': {
                      backgroundColor: '#0F1235',
                    },
                  }}>
                  <Image priority src={'/icons/tick.svg'} width={13} height={9} alt='tick' />
                  <Typography fontSize={'0.9rem'} color='#F1F7FA'>
                    I&apos;m ready to upload memories
                  </Typography>
                </MuiButton>
              </Box>
            </>
          )}
          {openModal && <TypeStory handleBack={backtostory} />}
        </>
      )}
    </>
  );
};
